module.exports = __webpack_public_path__ + "img/score.5de431d7.svg";